import jwtDecode from 'jwt-decode';

export default function jwtDecodeToken(token = '') {
    let res = {};
    try {
        // need replace the Bearer header to avoid Uncaught InvalidTokenError {message: "Invalid token specified: Cannot read property 'replace' of undefined"}       
        const jwtToken = jwtDecode(token.replace('Bearer ', ''));
        if (typeof jwtToken === 'object') {
            res = { jwtToken, decodeSuccess: true}
        }
        
    } catch (e) {
        res = { decodeSuccess: false, decodeErr: e}
    }
    return res;
};


// WEBPACK FOOTER //
// ./app/lib/auth/jwtDecodeToken.js